module.exports = __webpack_public_path__ + "static/media/5s.d7246b0f.png";